// src/components/ResponsiveOrderContainer.jsx
import { useMediaQuery } from "@mui/material";
import theme from "../styles/themes/theme";
import MobileBottomSheet from "./MobileBottomSheet";
import DesktopSideDrawer from "./DesktopSideDrawer";

export default function ResponsiveOrderContainer() {
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // < 900px

  return isMobile ? <MobileBottomSheet /> : <DesktopSideDrawer />;
}